<template>
  <div>
    <v-tabs
      v-if="!is_mobile"
      :value="correct_tab(current_tab)"
      icons-and-text
      align-with-title
      hide-slider
      id="qmkey-draggable-tabs"
      @change="change_tab"
    >
      <v-tab
        v-for="(inlines,index) in data"
        :key="index"
        :draggable="sortable"
        :id="tabs_id_common+index"
        @click="change_tab(index)"
      >
        <div class="drag-event-no-target d-flex">
          <div class="drag-event-no-target d-flex">
            <span style="align-self: center;">{{ inlines.id }}</span>
          </div>
            <DeleteButton
              v-if="!readonly"
              custom_icon="mdi-close"
              title="Delete Tab"
              :text="inlines.id"
              small_button
              @submit="delete_tab()"
            >
              <template v-slot:content>
                <v-tabs
                  icons-and-text
                  align-with-title
                  hide-slider
                >
                  <v-tab>
                    <span style="align-self: center;">{{ inlines.id }}</span>
                  </v-tab>
                </v-tabs>
              </template>
            </DeleteButton>
        </div>
      </v-tab>
      <slot name="add">
        <v-btn
          icon
          @click="new_tab"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </slot>
    </v-tabs>
  </div>
</template>

<style lang="scss">
.drag-event-no-target {
  pointer-events: none;
}
</style>

<script>
  import DeleteButton from '@/components/DeleteButton';
  export default {

    name: 'DraggableTabs',

    components: {
      DeleteButton,
    },

    props: {
      data: {default: ()=>([])},
      is_mobile: Boolean,
      current_tab: Number,
      roles: {default: ()=>({})},
      sortable: Boolean,
      readonly: Boolean,
    },
        
    data: () => ({
      tab: null,
      target: null,
      moving_tab: null,

      tabs_id_common: 'qmkey_tab_',
    }),

    computed: {
    },

    mounted() {
      this.generate_listeners();
    },

    updated() {
    },

    beforeDestroy() {
      this.remove_listeners();
    },

    methods: {

      correct_tab(tab) {
        if (tab != this.tab) {
          this.tab = tab;
        }
        return tab;
      },

      generate_listeners() {
        this.target = document.getElementById('qmkey-draggable-tabs');
        if (!!this.target) {
          this.target.addEventListener('dragstart',(ev)=>{this.start_moving_tab(ev)})
          this.target.addEventListener('dragend',(ev)=>{this.stop_moving_tab(ev)})
          this.target.addEventListener('drop',this.move_item)
          this.target.addEventListener('dragover',(ev)=>{ev.preventDefault();})
        }
      },

      remove_listeners() {
        if (!!this.target) {
          this.target.removeEventListener('dragstart',(ev)=>{this.start_moving_tab(ev)})
          this.target.removeEventListener('dragend',(ev)=>{this.stop_moving_tab(ev)})
          this.target.removeEventListener('drop',this.move_item)
          this.target.removeEventListener('dragover',(ev)=>{ev.preventDefault();})
        }
      },

      move_item(ev) {
        const drop_target = ev.target;
        const index_id = drop_target.id.split(this.tabs_id_common)[1];

        if (index_id >= 0) {
          let res = [...this.data];
          const element = res[this.moving_tab];
          if(this.moving_tab < index_id) {
            res.splice(this.moving_tab, 1);
            res.splice(index_id, 0, element);

          } else if (this.moving_tab > index_id) {
            res.splice(this.moving_tab, 1);
            if (index_id >= res.length) {
              res.push(element)
            } else {
              res.splice(index_id, 0, element);
            }
          }

          this.update_tabs(res);
        }
      },

      change_tab(tab) {
        this.$emit('change_tab',tab)
      },

      update_tabs(tabs) {
        this.$emit('update',tabs);
      },

      start_moving_tab(ev) {
        const drop_target = ev.target;
        const index_id = drop_target.id.split(this.tabs_id_common)[1];
        if (index_id >= 0) {
          this.moving_tab = index_id;
        }
      },

      stop_moving_tab(ev) {
        this.moving_tab = null;
      },

      delete_tab() {
        //TODO
      },

      new_tab() {
        //TODO
      },
      
    },

    watch: {
    },
  }
</script>